import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import { LinkButton } from 'src/components/atoms/button/Button';
import { DefaultPageProps, HistoryProps } from 'src/constants/Interface';
import StyleConfig from 'src/constants/StyleConfig';

type Props = DefaultPageProps &
  HistoryProps & {
    ownErrCode?: number;
    children?: React.ReactNode;
  };

class ErrorPage extends Component<Props> {
  getErrorCodeFromState = () => {
    const { history, ownErrCode } = this.props;
    const errCode = ownErrCode
      ? ownErrCode
      : history.location.state && history.location.state.errCode
      ? history.location.state.errCode
      : 500;
    // console.warn(errCode, "errPage View");
    return errCode;
  };

  getErrorTitle = () => {
    const errCode = this.getErrorCodeFromState();
    switch (errCode) {
      case 403:
        return 'ページの閲覧権限がありません';
      case 404:
        return 'ページが存在しません';
      case 500:
      default:
        return 'System Error';
    }
  };

  render() {
    const errTitle = this.getErrorTitle();
    return (
      <DefaultLayout {...this.props}>
        <Block>
          <h1 className="hdg">{errTitle}</h1>
          {this.props.children ? this.props.children : null}
          <LinkButton url={'/'} text="トップに戻る" isDisabled={false} />
        </Block>
      </DefaultLayout>
    );
  }
}

const Block = styled.div`
  padding: 0 ${StyleConfig.HELPER.M20};
  .hdg {
    margin: 24px auto;
  }
`;

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
